<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-button
          style="padding: 0; margin: 20px"
          type="text"
          icon="el-icon-back"
          @click="toManager()"
        >
          返回
        </el-button>

        <el-input
          class="search-el"
          size="mini"
          v-model="query.title"
          clearable
          placeholder="请输入标题"
        ></el-input>
        <el-button type="primary" size="mini" @click="getList()"> 查询 </el-button>
        <el-button type="primary" size="mini" @click="toCreate()"> 添加</el-button>

        <el-button v-if="liveInfo.configuration != undefined && liveInfo.configuration.is_vertical_screen == 1" type="primary" size="mini" @click="search.chooseOrgVisible = true"> 添加优惠券</el-button>
      </el-col>
    </el-row>

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column label="标题" align="center" min-width="15%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toCreate(row.id)">
              <div>{{ row.title }}</div>
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <img v-if="row.resource != null" :src="row.resource" style="width: 48px; height: 35px;" alt="" />
          </template>
        </el-table-column>

        <el-table-column label="跳转目标" align="center" min-width="15%">
          <template slot-scope="{ row }">
            {{ filterBannerTarget(row.target) }}<br>
            <div v-if="row.target_id > 0">目标对象ID： {{ row.target_id }}</div>
            <div v-if="row.target == 'target_h5'">目标对象地址： {{ row.address }}</div>
            <div v-if="row.target == 'live_detail'">价格： {{ row.price }}</div>
            <div v-if="row.target == 'live_detail'">直播时间： {{
                formatDateTime(row.begin_at, "yyyy-MM-dd hh:mm") +
                " ~ " +
                formatDateTime(row.end_at, "hh:mm")
              }}</div>
            <div v-if="row.target == 'coupon'">{{ row.remark }}</div>
          </template>
        </el-table-column>

        <el-table-column label="排序" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateSort(row.id)">
              <div>{{ row.sort }}</div>
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          prop="send_times"
          label="发送次数"
          align="center"
          min-width="4%"
        ></el-table-column>

        <el-table-column label="渠道推广位" align="center" min-width="8%">
          <template slot-scope="{ row }">
            {{ getChannelItemName(row.source) }}
            <el-button type="text" size="small" @click="channelItem.id = row.id; channelItem.chooseOrgVisible = true;">
              设置
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="带货订单" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toOrderList(row.source)">
              查看
            </el-button>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <el-button type="danger" size="mini" @click="del(row.id)">
              删除
            </el-button>
            <el-button size="mini" @click="send(row.id)">
              发送
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>

    <el-dialog
      title="选择优惠券"
      :visible.sync="search.chooseOrgVisible"
      :modal="false"
      :close-on-click-modal="true"
      :before-close="addEditFormOnClose"
      width="75%"
    >
    <el-form :inline="true" :model="search.query">
        <!-- 模糊查询 -->
        <el-form-item>
          <el-input
            size="mini"
            v-model="search.query.name"
            placeholder="请输入优惠券名称"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="searchData()">
            查询
          </el-button>
        </el-form-item>
      </el-form>

      <!--列表-->
      <el-table
        border
        :data="search.result.data"
        highlight-current-row
        v-loading="search.listLoading1"
        style="..."
        size="mini"
      >
        <el-table-column
          label="优惠券ID"
          align="center"
          min-width="6%"
          prop="id"
        >
        </el-table-column>

        <el-table-column
          label="名称"
          align="center"
          min-width="20%"
          prop="name"
        >
        </el-table-column>

        <el-table-column
          label="满减"
          align="center"
          min-width="8%"
        >
          <template slot-scope="{ row }">
            <div>{{ "满 " + row.start + " 减 " + row.reduce }}</div>
          </template>
        </el-table-column>

        <el-table-column
          label="起止时间"
          align="center"
          min-width="12%"
        >
          <template slot-scope="{ row }">
            <div>{{ row.begin_at + " ~ " + row.expire_at }}</div>
          </template>
        </el-table-column>
        
        <el-table-column
          label="库存"
          align="center"
          min-width="10%"
        >
        <template slot-scope="{ row }">
            {{ (row.stock - row.get_user) }}
          </template>
        </el-table-column>
        
        <el-table-column label="操作" align="center" min-width="8%">
          <template slot-scope="{ row }">
            <el-button type="primary" size="mini" @click="selectProduct(row)">
              确定
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="searchData"
        :current-page.sync="search.query.page"
        :page-size="search.query.limit"
        layout="total, prev, pager, next, jumper"
        :total="search.result.total"
      >
      </el-pagination>
    </el-dialog>

    <el-dialog
      title="设置渠道推广位"
      :visible.sync="channelItem.chooseOrgVisible"
      :modal="false"
      :close-on-click-modal="true"
      width="60%"
      :before-close="channelItemClose"
    >
    <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="渠道名称">
          <el-select
            class="search-el"
            size="small"
            v-model="channelItem.channel_id"
            placeholder="请选择推广渠道"
            clearable
            filterable
            @change="channelChange($event)"
          >
            <el-option
              v-for="item in channelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="推广位名称">
          <el-select
            class="search-el"
            size="small"
            v-model="channelItem.channel_item_id"
            placeholder="请选择推广位"
          >
            <el-option
              v-show="channelItem.channel_id > 0"
              v-for="item in channelItemList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button
            size="small"
            type="primary"
            @click="setChannelItem()"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getBannerTargetList,
} from "@/api/banner";
import {
  getMessageList,
  deleteMessage,
  updateMessageSort,
  sendMessage,
  messageAddCoupon,
  messageSetChannelItem
} from "@/api/live";
import {
  getCouponList
} from "@/api/coupon";

import { getChannelList, getChannelItemList } from "@/api/cChannel";
import { formatDateTime } from "@/api/common";

export default {
  data: function () {
    return {
      list: [],
      loading: false,
      bannerTargetList: [],
      total: 0,
      liveInfo: {},
      query: {
        page: 1,
        limit: 10,
        course_id: this.$route.query.course_id,
        period_id: this.$route.query.period_id,
        title: "",
        type: "",
        status: "",
      },

      search: {
        chooseOrgVisible: false,
        listLoading1: false,
        query: {
          name: "",
          page: 1,
          limit: 10,
        },
        result: {
          total: 0,
          data: [],
        },
      },

      channelList: [],
      channelList1: [],
      channelItemList: [],
      channelItemList1: [],
      channelItem: {
        chooseOrgVisible: false,
        id: 0,
        channel_id: '',
        channel_item_id: '',
      },
    };
  },
  beforeRouteLeave(to,from,next){
    to.meta.keepAlive = true
    next(0)
  },
  created: function () {
    getBannerTargetList().then((response) => {
      this.bannerTargetList = response.data;
    });
    getChannelList({ only_name: 1 }).then((response) => {
      this.channelList = response.data;
      response.data.forEach((item) => {
        this.channelList1[(item.id).toString()] = item.name;
      });
    });
    getChannelItemList({ only_name: 1 }).then((response) => {
      this.channelItemList = response.data;
      response.data.forEach((item) => {
        this.channelItemList1[(item.id).toString()] = item.name;
      });
    });
    this.getList();
  },
  methods: {
    formatDateTime(datetime, fmt) {
      return formatDateTime(datetime, fmt);
    },

    toOrderList(source) {  
      if (window.location.host == 'dev.backend.zhangdefenspace.com') {
        window.open('http://dev.admin.defen.hzxinquanzi.com/?c=order&m=order_list&p=20&item=0&show=1&source=' + source, '_blank');
      } else {
        window.open('http://admin.defen.hzxinquanzi.com/?c=order&m=order_list&p=20&item=0&show=1&source=' + source, '_blank');
      }
    },

    channelItemClose() {
      this.channelItem = {
        chooseOrgVisible: false,
        id: 0,
        channel_id: '',
        channel_item_id: '',
      };
    },
    channelChange(channel_id) {
      this.channelItem.channel_id = channel_id;
      this.channelItem.channel_item_id = '';
      getChannelItemList({ only_name: 1, channel_id:  channel_id}).then((response) => {
        this.channelItemList = response.data;
      });
    },
    setChannelItem() {
      if (this.channelItem.id <= 0 || Number(this.channelItem.channel_id) <= 0 || Number(this.channelItem.channel_item_id) <= 0) {
        this.$message({
          showClose: true,
          message: "请选择正确的渠道和推广位",
          type: "error",
        });
        return false;
      }
      messageSetChannelItem({
        id: this.channelItem.id,
        source: 'CH_' + this.channelItem.channel_id + '_' + this.channelItem.channel_item_id,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });

      this.channelItemClose();
    },

    getChannelItemName(source) {
      if (source.slice(0, 3) == 'CH_') {
        var arr = source.split('_');
        if (arr.length == 3) {
          return this.channelList1[arr[1]] + '【' + this.channelItemList1[arr[2]] + '】';
        }
      }
      return '无';
    },

    selectProduct(row) {
      messageAddCoupon({
        period_id: this.query.period_id,
        coupon_id: row.id,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });

      this.addEditFormOnClose();
    },
    addEditFormOnClose() {
      this.search.query.page = 1;
      this.search.query.name = "";

      this.search.result = {
        total: 0,
        data: [],
      };
      this.search.chooseOrgVisible = false;
    },
    // 查询方法
    searchData() {
      if (this.search.query.name == '') {
        this.$message({
          showClose: true,
          message: "请输入优惠券名称",
          type: "error",
        });
        return false;
      }
      this.search.listLoading1 = true;
      getCouponList(this.search.query).then((response) => {
        this.search.result.data = response.data.list;
        this.search.result.total = response.data.total;
        this.search.listLoading1 = false;
      });
    },

    toManager() {
      this.$router.back();
      // this.$router.push({
      //   path: "/live/manage",
      //   query: {
      //     id: this.query.course_id,
      //     period_id: this.query.period_id
      //   },
      // });
    },

    filterBannerTarget(target) {
      if (target == 'coupon') return '优惠券';
      return this.bannerTargetList[target];
    },

    toCreate(id) {
      this.$router.push({
        path: "/live/messageInfo",
        query: {
          course_id: this.$route.query.course_id,
          period_id: this.$route.query.period_id,
          id: id,
        },
      });
    },

    getList() {
      this.loading = true;
      getMessageList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        if (response.data.info != undefined) {
          this.liveInfo = response.data.info;
        }
        this.loading = false;
      });
    },

    updateSort(id) {
      this.$prompt("请输入排序", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /[0-9]/,
        inputErrorMessage: "格式不正确",
      })
        .then(({ value }) => {
          updateMessageSort({
            id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        })
        .catch(() => {});
    },

    del(id) {
      this.$confirm("此操作将删除该对象, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        deleteMessage({
          id: id,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "删除成功",
              type: "success",
            });
          } else {
            this.$message({
              showClose: true,
              message: response.message,
              type: "error",
            });
          }
        });
      });
    },

    send(id) {
      sendMessage({
        id: id,
      }).then((response) => {
        if (response.status == 2000) {
          this.getList();
          this.$message({
            showClose: true,
            message: "成功",
            type: "success",
          });
        } else {
          this.$message({
            showClose: true,
            message: response.message,
            type: "error",
          });
        }
      });
    },
  },
  mounted() {},
};
</script>

<style>
</style>